<template>
    <img src="/images/promo/hero-section/chart-increasing.png"
     alt="Chart increasing" />
</template>

<script>
export default {};
</script>
